import styled from "styled-components";
import DestinationImg from "../../assets/onboardImg4.jpg";
import { device } from "../../globalAssets/breakpoints";
import { desktop } from "../../globalAssets/fontsize";

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    `linear-gradient(to right, rgba(16,171,222,0) -25%,rgba(0,116,255,0.7) 150%),url(${DestinationImg})`};
  background-attachment: fixed;
  background-position: center;
  background-repeat: repeat;
  background-size: 100vw 100vh;
  & > div {
    width: 80%;
  }
  h3 {
    color: ${(props) => props.theme.white};
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    & > span {
      text-transform: capitalize;
    }
  }
  h2 {
    color: ${(props) => props.theme.white};
    font-weight: 400;
    text-align: center;
    font-size: 14px;
  }
  @media ${device.laptop} {
    & > div {
      width: 50%;
    }
    h3 {
      font-size: ${desktop.large};
    }
    h2 {
      font-size: ${desktop.medium};
    }
  }
`;
